// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Button from '../../../../Button';
import Row from '../../../../Row';

export const S = {
  Container: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
  `,
  Row: styled(Row)`
    align-items: center;
  `,
  DetailsRow: styled.div`
    width: 100%;
  `,
  InformationContainer: styled.div`
    width: 434px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 71px;

  `,
  Title: styled.div`
    font: 700 20px Noto Sans TC;
    color: #434343;
    line-height: 29px;
    margin-bottom: 14px;
  `,
  DetailsTitle: styled.div`
    font: 700 20px Noto Sans TC;
    color: #434343;
    line-height: 40px;
  `,
  DetailsText: styled.div`
    font: 400 18px Noto Sans TC;
    line-height: 36px;
    color: #434343;

    & + & {
      margin-left: auto;
    }
  `,
  ScoreText: styled.div`
    font: 700 36px Noto Sans TC;
    color: #434343;
    margin-left: 35px;
  `,
  TextButton: styled.div`
    width: 142px;
    font-family: Noto Sans TC;
    font-size: 18px;
    line-height: 26px;
    color: #EF8200;
    cursor: pointer;
  `,
  Button: styled(Button)`
    width: 142px;

    & + & {
      margin-left: 25px;
    }
  `
};
